import {
  faPaw,
  faCalendar,
  faDog,
  faHouse,
  faCarSide,
  faCircleParking,
  faCapsules,
  faCat,
  faFlowerDaffodil,
  faRabbit,
  faBird,
  faFishFins,
  faVestPatches,
  faTennisBall,
  faWaterLadder,
  faStore,
  faHouseChimneyMedical
} from "@fortawesome/pro-solid-svg-icons";

const facilityIcons = (icon) => {
  const list = {
    default: faPaw,
    calendar: faCalendar,
    dog: faDog,
    "home-alt": faHouse,
    "car-side": faCarSide,
    "circle-parking": faCircleParking,
    capsules: faCapsules,
    cat: faCat,
    "flower-daffodil": faFlowerDaffodil,
    rabbit: faRabbit,
    bird: faBird,
    "fish-fins": faFishFins,
    "vest-patches": faVestPatches,
    "tennis-ball": faTennisBall,
    "water-ladder": faWaterLadder,
    store: faStore,
    "house-chimney-medical": faHouseChimneyMedical
  };

  return list[icon] || list.default;
};

export default facilityIcons;
